import "core-js/modules/es.array.push.js";
import { request } from "@/js/http/http_request";
export default {
  name: "userContact",
  data: function data() {
    return {
      input: {
        first_name: "",
        last_name: "",
        email: "",
        subject: "",
        message: ""
      },
      errorLabels: {
        subject: "",
        message: ""
      },
      errorMessages: {
        mandatory: "This field is required"
      },
      stepContact: 1
    };
  },
  created: function created() {
    this.$EventBus.$emit("loading", false);
  },
  methods: {
    home: function home() {
      this.$router.push({
        name: "userHome"
      });
    },
    makeRequest: function makeRequest() {
      var instance = this;
      if (this.validateInputs()) {
        request("/v1/user/contact", "post", instance.input, true, "api").then(function (response) {
          instance.stepContact = 2;
        }).catch(function (err) {
          instance.$toasted.show("An error occured. Please contact an administrator.", {
            type: "error"
          });
        });
      }
    },
    validateInputs: function validateInputs() {
      this.errorLabels.subject = "";
      this.errorLabels.message = "";
      var valid = true;
      if (this.input.subject == "") {
        this.errorLabels.subject = this.errorMessages.mandatory;
        valid = false;
      }
      if (this.input.message == "") {
        this.errorLabels.message = this.errorMessages.mandatory;
        valid = false;
      }
      return valid;
    }
  }
};